import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

export function apiUrl(path) {
  if (!path) return path;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocurrió un error. Intenta nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function extractErrorMessage(err) {
  if (!err) return "Error desconocido";
  const detail = err.response?.data?.detail || err.response?.data?.message;
  return formatApiErrorDetail(detail) || err.message || "Error desconocido";
}
